import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvService } from 'src/app/services/env.service';

@Injectable()
export class FilesService {
  readonly baseUrl = `${this.env.URL_API_V1}/files`;
  constructor(private readonly http: HttpClient, private env: EnvService) {}

  upload(file: FormData) {
    return this.http.post<any>(`${this.baseUrl}/upload`, file);
  }

  /**
   * URL pública de un archivo subido (SCG-388). El back la arma con el Host
   * que le pasa nginx (sin puerto) y en http: en calidad y prod apunta al front
   * y no carga. Se rehace con la API real; el segmento de fecha es el que pone
   * el interceptor en las llamadas HTTP.
   */
  urlPublica(respuesta: string): string {
    const nombre = String(respuesta || '').split('/files/get/').pop();
    return `${this.env.URL_API_V1}/${Date.now()}/files/get/${nombre}`;
  }

  downloadPlantillaGrafo() {
    return this.http.get<any>(`${this.baseUrl}/downloadPlantillaGrafo`, {
      responseType: 'blob' as 'json',
    });
  }

  getFileByArrayBuffer(name) {
    return this.http.get<any>(`${this.baseUrl}/get/${name}`, {
      responseType: 'blob' as 'json',
    });
  }

  getFileByText(name) {
    return this.http.get(`${this.baseUrl}/get/${name}`, {
      responseType: 'text'
    });
  }

  
  transformarUrl(urlOriginal: string): string {
      const api = new URL(this.env.URL_API_V1);
      const targetHost = api.hostname;
      const nuevoPuerto = api.port;

      if (!urlOriginal.includes(targetHost)) {
          return urlOriginal; // Retorna la URL original si no cumple la condición
      }

      try {
          const url = new URL(urlOriginal);
          if (url.hostname !== targetHost) {
              return urlOriginal; 
          }
          url.port = nuevoPuerto;
          
          const urlConPuerto = url.toString();
          
          const resultadoFinal = urlConPuerto.replace(/^https?:/, ''); 
          
          return resultadoFinal;

      } catch (error) {
          return urlOriginal; // Manejo de errores si la URL es inválida
      }
  }


}
